export default {
  __name: 'ActionModal',
  props: {
    status: {
      type: String,
      default: ""
    }
  },
  emits: ["close-modal", "ok"],
  setup(__props, {
    emit
  }) {
    // @ts-check

    return {
      __sfc: true,
      emit
    };
  }
};